import { accountRequests } from "api/accountApi";
import React from "react";
import { FunctionField, Labeled, ReferenceField } from "react-admin";

const UserField = ({ label = "Потребител", source = "userId", labeled = false, emptyText = "-" }) => {
  const field = (
    <ReferenceField
      source={source}
      reference={accountRequests.getUsersSelect()}
      emptyText={emptyText}
    >
      <FunctionField
        render={rec =>
          rec.secondName ? `${rec.firstName} ${rec.secondName} ${rec.lastName}` : `${rec.firstName} ${rec.lastName}`
        }
      />
    </ReferenceField>
  );

  return labeled ? <Labeled label={label}>{field}</Labeled> : field;
};

export default UserField;
